import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { Map } from 'immutable';
import { START_EDIT, END_EDIT, TOGGLE_EDIT } from '@instructure/quiz-common';
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Map();
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var editingActions = _defineProperty(_defineProperty(_defineProperty({}, START_EDIT, state.set(action.componentId, true).set('initialFocusId', action.initialFocusId)), END_EDIT, state.set(action.componentId, false)), TOGGLE_EDIT, state.set(action.componentId, !state.get(action.componentId)));
  return editingActions[action.type] || state;
});